export const getAgeLimitError = (contract, errors) => {
    if (!contract.birth_date) {
        return errors;
    }
    const birthDate = new Date(contract.birth_date);
    if (isUnderAge(birthDate)) {
        const underAgeMessage = "Under age limit";
        if (!errors.birth_date) {
            errors.birth_date = [];
        }
        errors.birth_date.push(underAgeMessage);
    }
    return errors;
};
const isUnderAge = (birthDate) => {
    const AGE_LIMIT = 18;
    const dateLimit = new Date();
    dateLimit.setFullYear(dateLimit.getFullYear() - AGE_LIMIT);
    if (birthDate > dateLimit)
        return true;
    return false;
};
